import { render, staticRenderFns } from "./RatingScale.vue?vue&type=template&id=7a066f5c&scoped=true"
import script from "./RatingScale.vue?vue&type=script&lang=ts"
export * from "./RatingScale.vue?vue&type=script&lang=ts"
import style0 from "./RatingScale.vue?vue&type=style&index=0&id=7a066f5c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a066f5c",
  null
  
)

export default component.exports